import {
    AI_BRIEF_N_OUTLINE_CREDITS_REQUIRED,
    BRIEF_AI_CREDITS_REQUIRED,
    CONTENT_ONLY_AI_CREDITS,
    OPTIMIZER_AI_CREDITS_REQUIRED,
    OUTLINE_AI_CREDITS_REQUIRED,
} from '../components/common/tiptapEditor/constants/aiEditorConstants';

export const aiOptimizerContentTypes = [
    { value: 'blog_content', label: 'Blog Content' },
    { value: 'buyers_guide', label: 'Buyers Guide' },
    { value: 'ecommerce_page', label: 'E-commerce Page' },
    { value: 'homepage', label: 'Homepage' },
    { value: 'landing_page', label: 'Landing Page' },
    { value: 'product_review', label: 'Product Review' },
    { value: 'service_page', label: 'Service Page' },
];

export const AI_OPTIMIZER_BRIEF_N_OUTLINE = 'brief_n_outline';
export const AI_OPTIMIZER_WHOLE = 'whole_ai';

export const aiOptimizerOptions = [
    {
        value: AI_OPTIMIZER_BRIEF_N_OUTLINE,
        label: 'AI Brief and Outline only',
        credits: `(1 Optimizer + ${AI_BRIEF_N_OUTLINE_CREDITS_REQUIRED} AI credits)`,
    },
    {
        value: AI_OPTIMIZER_WHOLE,
        label: 'AI Brief, Outline, and First Draft',
        credits: `(1 Optimizer + ${OPTIMIZER_AI_CREDITS_REQUIRED} AI credits)`,
    },
];

export const aiOutlineOptions = {
    newBrief: {
        label: 'AI Brief',
        credits: `(${BRIEF_AI_CREDITS_REQUIRED} AI credit)`,
    },
    newOutline: {
        label: 'Create new AI outline',
        credits: `(${OUTLINE_AI_CREDITS_REQUIRED} AI credit)`,
    },
    generateContent: {
        label: 'Generate AI content from outline',
        credits: `(${CONTENT_ONLY_AI_CREDITS} AI credits)`,
    },
};

export const aiStatus = Object.freeze({
    QUEUED: 'queued',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    EXPIRED: 'expired',
    CANCELLED: 'cancelled',
    FAILED: 'failed',
    INCOMPLETE: 'incomplete',
    FINAL_STATUSES: ['completed', 'failed', 'expired', 'cancelled'],
    FINAL_FAILED_STATUSES: ['failed', 'expired', 'cancelled'],
});

export const aiInstanceTypes = Object.freeze({
    BRIEF: 'brief',
    OUTLINE: 'outline',
    CONTENT: 'content',
});
